import HousekeepingStatusBoardDispatcher from '../dispatcher/HousekeepingStatusBoardDispatcher'
import HousekeepingStatusBoardConstants from '../constants/HousekeepingStatusBoardConstants'
import { format, parseISO } from 'date-fns';

var objectAssign = require('object-assign');
var EventEmitter = require('events').EventEmitter.prototype;
var HousekeepingStatusBoardStore = objectAssign({}, EventEmitter, {

  _state: {
    currentDate: new Date,
    dateFormat: null,
    loading: false,
    readOnly: false,
    reservationSegments: [],
    requestCleaningPath: null,
    timeFormat: null,
  },

  /**
  * Event Listener, Event Emitter
  */
  emitChange: function () {
    this.emit(HousekeepingStatusBoardConstants.CHANGE_EVENT);
    this._state.forceUpdate = false;
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(HousekeepingStatusBoardConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(HousekeepingStatusBoardConstants.CHANGE_EVENT, callback);
  },

  /*
  * Initializes the store merging the options 
  *
  * @param {object} opts
  */
  init: function (opts) {
    objectAssign(this._state, opts);

    if (opts.currentDate) {
      this._state.currentDate = parseISO(opts.currentDate);//.split('T')[0] + ' 00:00:00');
    }

    this.emitChange();
  },

  /*
  * Go to the given date (loading reservations) 
  */
 gotoDate: function (date) {
  var self = this;

  self._state.currentDate = date;
  if (history.pushState) {
      var new_url = window.location.protocol + "//" + window.location.host + window.location.pathname + '?date=' + date.toString('yyyy-MM-dd');
      window.history.pushState({path: new_url}, '', new_url);
  }
  self.emitChange();
},
  /**
  * Makes AJAX call to refresh data
  */
  refreshData: function () {
    this.gotoDate(this._state.currentDate || new Date());
  },

  /***********/
  /* getters */
  /***********/

  getCurrentDate: function () {
    return this._state.currentDate;
  },

  getDataTableEndpoint: function () {
    return '/admin/housekeeping/date/' + format(this._state.currentDate, 'yyyy-MM-dd');
  },

  getDateFormat: function () {
    return this._state.dateFormat;
  },

  getLoading: function () {
    return this._state.loading;
  },

  getReadOnly: function () {
    return this._state.readOnly;
  },

  getReservationSegments: function () {
    return this._state.reservationSegments;
  },

  getRequestCleaningPath: function () {
    return this._state.requestCleaningPath;
  },

  getTimeFormat: function () {
    return this._state.timeFormat;
  }, 

});

HousekeepingStatusBoardStore.dispatchToken = HousekeepingStatusBoardDispatcher.register(function (payload) {
  switch (payload.action) {

    case HousekeepingStatusBoardConstants.INIT:
      HousekeepingStatusBoardStore.init(payload.opts);
      HousekeepingStatusBoardStore.emitChange();
      break;

    case HousekeepingStatusBoardConstants.GOTO_DATE:
      HousekeepingStatusBoardStore.gotoDate(payload.date);
      break;

    case HousekeepingStatusBoardConstants.REFRESH_DATA:
      HousekeepingStatusBoardStore.refreshData();
      break;

    default:
  }

});

/* silence the EventEmitter */
HousekeepingStatusBoardStore.setMaxListeners(0);

$(window).on('refresh_data_table', function () {
  if (HousekeepingStatusBoardStore._state.initialized) {
    HousekeepingStatusBoardStore.refreshData();
  }
});

export default HousekeepingStatusBoardStore